export default __webpack_public_path__ + "images/f0459bce328ed716702c5f98e1c2e236.png";